import { RoutePaths } from "src/app/model";

export const pages: {
  labelKey: string;
  value: RoutePaths;
}[] = [
  {
    labelKey: "nav.home",
    value: RoutePaths.HOME,
  },
  {
    labelKey: "nav.about",
    value: RoutePaths.ABOUT_US,
  },
  {
    labelKey: "nav.services",
    value: RoutePaths.SERVICES,
  },
  {
    labelKey: "nav.projects",
    value: RoutePaths.PROJECTS,
  },
  {
    labelKey: "nav.tools",
    value: RoutePaths.TOOLS,
  },
  // {
  //   labelKey: "nav.blogs",
  //   value: RoutePaths.BLOGS,
  // },
  {
    labelKey: "nav.contact",
    value: RoutePaths.CONTACTS,
  },
];
